module.exports = function (app) {
    app.service("MonitoringService", [
        "MonitoringFactory",
        function (MonitoringFactory) {

            const monitoringTool = MonitoringFactory(MONITORING_TOOL);

            this.logAndRethrow = function (error, module, method, customAttributes) {
                try {
                    monitoringTool.logAndRethrow(error, module, method, customAttributes);
                } catch (err) {
                    console.error(`Error in logAndRethrow: ${err.message}`);
                }
            };

            this.addPageAction = function (actionName, customAttributes) {
                try {
                    monitoringTool.addPageAction(actionName, customAttributes);
                } catch (err) {
                    console.error(`Error in addPageAction: ${err.message}`);
                }
            };

            this.noticeError = function (error, module, method, customAttributes) {
                try {
                    monitoringTool.noticeError(error, module, method, customAttributes);
                } catch (err) {
                    console.error(`Error in noticeError: ${err.message}`);
                }
            };

            this.setCustomEventAttribute = function (customEventAttributeKey, customEventAttributeValue) {
                try {
                    monitoringTool.setCustomEventAttribute(customEventAttributeKey, customEventAttributeValue);
                } catch (err) {
                    console.error(`Error in setCustomEventAttribute: ${err.message}`);
                }
            };
        },
    ]);
};